import { getClient } from '@zg-rentals/ts-client-http-client';

/**
 * Shared HTTP client for calls to backends fronted at the `/rental` path
 * (capps, maintenance-tracker, rent-payment, z-calendar, satellite).
 */
export const client = getClient().extend({ prefixUrl: process.env.NEXT_PUBLIC_RENTAL_PREFIX });
